export default {
  //  --------------------- 青岛清算所银行开始 (30)-------------
  // 出金
  param_marketOutFund_qd: {
    url: '/qd-common-marginservice/margin/marketOutFund',
    param: {}
  },
  // 获取网银端入金信息
  param_queryBankName: {
    url: '/qd-common-marginservice/margin/queryBankName',
    param: {}
  },
//  --------------------- 青岛清算所银行结束-------------
}
